import CalendarPopup from './CalendarPopup.vue';

export default CalendarPopup;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/popup/index.ts